import { useCallback, useRef } from 'react';

export default function useSkipFirstFetchIfResolvedOnServer(
  resolvedOnServer: boolean
) {
  const isFirstRenderAndResolvedOnServer = useRef(resolvedOnServer);

  return useCallback(() => {
    if (isFirstRenderAndResolvedOnServer.current) {
      isFirstRenderAndResolvedOnServer.current = false;

      return true;
    }

    return false;
  }, []);
}
